﻿import { IMask } from "react-imask";
import { Masked } from "imask";

export const formatPhone = <T extends string | null | undefined>(phone: T, inputMask = "+1 (000) 000-0000"): T => {
    return mask(phone, { mask: inputMask } as Masked<string>);
};

export const formatSsn = <T extends string | null | undefined>(ssn: T, inputMask = "000-00-0000"): T => {
    return mask(ssn, { mask: inputMask } as Masked<string>);
};

export const maskSsn = <T extends string | null | undefined>(ssn: T, inputMask = "•••-••-0000"): T => {
    return mask(ssn, { mask: inputMask } as Masked<string>);
};

export const formatZip = <T extends string | null | undefined>(zip: T, inputMask = "00000-0000"): T => {
    return mask(zip, { mask: inputMask } as Masked<string>);
};

export const formatEin = <T extends string | null | undefined>(ein: T, inputMask = "00-0000000"): T => {
    return mask(ein, { mask: inputMask } as Masked<string>);
};

export const mask = <T extends string | null | undefined>(value: T, mask: Masked): T => {
    const iMask = IMask.createMask(mask);
    if (value) {
        iMask.resolve(value);
        // @ts-ignore
        return iMask.value;
    } else {
        return value;
    }
};
